import z from 'zod';

// Helper to validate ISO date strings
// Accepts: null, undefined, empty string, or valid ISO date string
export const isoDateString = z.string().refine(
    (val) => {
        // Allow empty strings
        if (val === '') return true;
        // Validate ISO date format
        const date = new Date(val);
        return !isNaN(date.getTime());
    },
    { message: 'Invalid date format' },
);

// Helper to validate date strings in YYYY-MM-DD format
export const dateString = (message: string) =>
    z.string({ message }).regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format');
